import WebhookManagement from './WebhookManagement';
import APIKeyManagement from './APIKeyManagement';
import { INTEGRATIONS } from '../../utils/constant';

const integrationRoutes = [
  {
    path: '/integrations/webhooks',
    element: <WebhookManagement />,
    permission: INTEGRATIONS,
  },
  {
    path: '/integrations/api-keys',
    element: <APIKeyManagement />,
    permission: INTEGRATIONS,
  },
];

export default integrationRoutes;
